<template>
  <div class="page withdraw-index">
    <navigation type="second-level" :sticky="true" @click="back" :customClickEvent="true">
      我要提现
    </navigation>

    <!-- 提现金额调整 -->
    <div class="withdraw-money card-panel">
      <div class="title">当前可用额度（元）{{ productRemaindLimit | currency }}</div>

      <div class="money-operate">
        <div class="money" @click="openKeyboard">
          {{ form.applyAmt | amount }}
        </div>
        <div class="max-withdraw" @click="maxWithdraw">最大提现</div>
      </div>

      <div class="money-range clearfix">
        <div class="min-money">
          最低(元) {{ productMinLimit | amount }}
        </div>
        <div class="max-money">
          最高(元) <em>{{ productMaxLimit | amount }}</em>
        </div>
      </div>
    </div>

    <!-- 提现参数 -->
    <form class="form card-panel" ref="form">
      <div class="form-item underline-un-focus">
        <nd-choose
          label="怎么花"
          :valueKey="['key', 'description']"
          :data="dictionary.loanPurpose"
          v-model="form.purpose"
          @change="purposeChange"
        >
        </nd-choose>
      </div>

      <div class="form-item underline-un-focus">
        <nd-choose
          label="分几期"
          :data="termList"
          :placeholder="placeholder"
          v-model="form.applyTerm"
          :beforeClick="beforeSelectTerm"
          @change="termChange"
        >
        </nd-choose>
      </div>

    </form>
    <section class="bottom">
      <nd-button class="confirm" @click="next" :disabled="isDisabled">{{ canLoanApply ? '下一步：预览提现详情' : '暂不可提现'}}</nd-button>
      <section class="read-protocol">
        <span>综合年化利率以实际每笔订单放款审核为准</span>
      </section>
    </section>


    <!--自定义键盘-->
    <nd-keyboard
      ref="keyboard"
      :stepSize="lendingAmountStep"
      :start-money="startMoney"
      :visible="keyboardVisible"
      @changeResult="getKeyboardInput"
      @step="stepHandler"
    ></nd-keyboard>
    <nd-dialog
      v-model="tipsVisible"
      class="tips-dialog"
      :footer="false"
      :closeBtn="true"
      @close="tipsVisible=false"
    >
      <div class="tips-content">
        <div class="header">
          温馨提示
        </div>
        <p class="body">
          尊敬的用户，我们发现您的最高可提现金额<span
            class="highlight"
          >{{ productMaxLimit | amount }}元</span>
        </p>
        <p class="body">
          您提现成功后，需要结清借款后才可以再次发起提现哦，请您妥善评估提现金额以备不时之需。
        </p>
        <nd-button class="footer" @click="confirm">
          立即提现{{ productMaxLimit | amount }}元
        </nd-button>
        <p class="cancel" @click="cancel">已知悉，暂不需要这么多金额</p>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
let throttleLastTimer = 0
let throttleGutter = 1000

export default {
  name: 'withdraw-index',

  description: '我要提现',

  customReadyNotify: true,
  components: {
 
  },
  data () {
    return {
      showPricingPopup: false, // 是否弹出IRR24利率弹窗
      detentionVisible: false,
      activityVisible: false,
      form: {
        applyAmt: '',
        applyTerm: '',
        purpose: '',
        bankCardNo: ''
      },
      productRemaindLimit: 0,
      productMaxLimit: 5000,
      productMinLimit: 5000,
      lendingAmountStep: 500,
      productSubList: [],
      amtProductList: [], // 通过金额查询子产品
      fundCode: '',
      // 陀螺仪旋转发生次数
      deviceorientationEventOccurCount: 0,
      keyboardVisible: false,
      showNotice: false,
      stepCount: 0,
      tipsVisible: false,
      canLoanApply: true,
      canotLoanReason: '',
      canLoanCode: '',
      popupList: [],
      activityTempleVisible: false,
      currentActivity: {},
      canLoanApplyMessage: '',
      svipLimitTips: '', // 温馨提示
      couponSerialNos: this.$route.query.couponSerialNos, // 券包运营活动跳转过来的券号
      couponType: this.$route.query.couponType, // 券包运营活动跳转过来的类型
      svipDialog: false,
      payDialog: false,
      svipData: {}, // svip弹窗数据
      payStatusInfo: {} // 过期返回的数据

    }
  },

  computed: {
    ...mapState('withdraw', {
      loanParameter: (state) => state.loanParameter,
      withdrawForm: (state) => state.withdrawForm,
      fundData: (state) => state.fundData
    }),

    ...mapState({
      dictionary: state => state.dictionary,
      caseList: state => state.caseList
    }),

    placeholder () {
      return this.termList.length > 0 ? '请选择' : '暂无支持分期'
    },

    termList () {
      var cycles = this.amtProductList.map((item) => {
        return {
          name: item + '个月',
          value: item
        }
      })
      return cycles
    },

    isDisabled () {
      return !(
        this.form.applyAmt &&
        this.form.applyTerm &&
        this.form.purpose
      )
    },

    // 键盘起始值
    startMoney () {
      return Number(this.form.applyAmt)
    }
  },

  watch: {
    tipsVisible (bool) {
      if (bool) {
        this.$report({ id: 10182, args: { visible: 1 } })
      } else {
        this.$report({ id: 10182, args: { visible: 0 } })
      }
    },
    detentionVisible (value) {
      this.$report({
        id: 10119,
        args: {
          visible: value ? 1 : 0
        }
      })
    },

    activityVisible (value) {
      this.$report({
        id: 10121,
        args: {
          position: 'page_withdraw',
          visible: value ? 1 : 0,
          status: this.currentActivity.activeType
        }
      })
    },

    async  'form.applyAmt' (value) {
      if (value <= 0) {
        return
      }
      this.getAmtProduct(value)
    },

    activityTempleVisible (value) {
   
    },
    showPricingPopup (value) {
      this.$report({
        id: 10300,
        args: {
          visible: value ? 1 : 0
        }
      })
    }
  },
  async created () {
    // 初始化表单
    this.form = this.withdrawForm
    await Promise.all([
      this.fetchDictionaryX(),
      this.getLoanParameter()
    ])
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('withdraw', [
      'getLoanParameterX',
      'getLoanTrialX',
      'getFundRouteX',
      'canLoanX',
      'amtProductX',
      'getMaxLimit',
      'judgeMissingX'
    ]),
    ...mapActions('vip', [
      'memberInfo',
      'orderList'
    ]),
    ...mapActions('user', ['getUserInfoX']),

    ...mapMutations('withdraw', ['setWithdrawForm']),

    ...mapActions(['fetchDictionaryX', 'getCaseListX']),
    // 获取借款要素
    async getLoanParameter () {
      const response = await this.getLoanParameterX({
        loanPlatform: 'TMD'
      })
      if (response.success && response.data) {
        // 初始化range区间及间隔
        if (this.isExternalChannel) {
          // 初始化range区间及间隔
          this.productRemaindLimit = response.data.productMaxLimit
          this.productMaxLimit = Math.floor(response.data.productMaxLimit / 100) * 100
          this.productMinLimit = response.data.productMinLimit
          this.lendingAmountStep = response.data.lendingAmountStep
            ? response.data.lendingAmountStep
            : 500
          // 额度默认取最大
          this.form.applyAmt = this.form.applyAmt || this.productMaxLimit
          // 产品列表
          this.productSubList = response.data.productSubList
        } else {
          this.productRemaindLimit = response.data.creditLimit
          // this.productMaxLimit = Math.floor(response.data.productMaxLimit / 100) * 100
          this.productMinLimit = response.data.productMinLimit
          this.lendingAmountStep = response.data.lendingAmountStep
            ? response.data.lendingAmountStep
            : 500
          this.productMaxLimit = response.data.userMaxLimit
          // 额度默认取后端返回
          this.form.applyAmt = this.form.applyAmt || response.data.productDefaultAmt
          // 产品列表
          this.productSubList = response.data.productSubList
        }
      } else {
        throw new Error('借款要素获取失败')
      }
      return response.data
    },

    // 通过金额查询子产品
    async getAmtProduct (applyAmount) {
      this.form.applyTerm = null
      const response = await this.amtProductX({
        loanPlatform: 'TMD',
        applyAmount: applyAmount
      })
      if (response.success) {
        let terms = response.data
        this.amtProductList = terms
        if (terms && terms.length > 0) {
          this.form.applyTerm = terms[terms.length - 1]
        }
      } else {
        this.amtProductList = []
      }
    },

    // 键盘返回值
    async getKeyboardInput (value) {
      if (value) {
        if (value === 0) {
          this.closeKeyboard()
        } else if (value > 0 && value < this.productMinLimit) {
          this.form.applyAmt = this.productMinLimit
          this.$message(
            `您当前最小提现金额为${this.productMinLimit}元`
          )
        } else if (
          value >= this.productMinLimit &&
          value <= this.productMaxLimit
        ) {
          if (value % this.lendingAmountStep === 0) {
            this.form.applyAmt = value
          } else {
            this.form.applyAmt =
              Math.ceil(value / this.lendingAmountStep) *
              this.lendingAmountStep
            this.$message(
              `每笔提现金额必须为${this.lendingAmountStep}的整数倍`
            )
          }
        } else if (value > this.productMaxLimit) {
          this.form.applyAmt = this.productMaxLimit
          this.$message(
            `您当前最大提现金额为${this.productMaxLimit}元`
          )
        }
        if (this.productMaxLimit > value) {
          let { success, data } = await this.getMaxLimit({ 'loanPlatform': 'TMD' }) // 最大提现金额判断
          if (success && data) {
            this.tipsVisible = true
          }
        }
      }
      this.closeKeyboard()
      // 最大提现金额判断
    },
    // 关闭键盘
    closeKeyboard () {
      this.$report({
        id: 10091,
        args: {
          visible: 0,
          target: this.stepCount
        }
      })
      this.stepCount = 0
      this.keyboardVisible = false
    },

    // 点击步长
    stepHandler () {
      this.stepCount++
    },

    // 打开键盘
    openKeyboard () {
      this.$report({
        id: 10086
      })
      this.$report({
        id: 10091,
        args: {
          visible: 1
        }
      })
      this.$refs.keyboard.init(this.startMoney)
      this.keyboardVisible = true
    },

    beforeSelectTerm () {
      if (this.termList.length === 0) {
        // this.$message('当前没有可匹配的期数')
        return Promise.resolve(false)
      }
      return Promise.resolve(true)
    },

    async getFundRoute () {
      const params = {
        routeType: 'LOAN',
        loanPlatform: 'TMD',
        applyAmount: this.form.applyAmt,
        totatlTermNo: this.form.applyTerm,
        productCode: 'TMDP',
        routeWay: '1'
      }
      const response = await this.getFundRouteX(params)
      if (response.success) {
        if (!response.data || response.data.length === 0) {
          this.$message('今日额度已抢完，明天再来吧')
        } else {
          this.$storage.set('fundRoute', response.data[0])
          this.fundCode = response.data[0].fundCode
        }
      } else {
        this.$storage.remove('fundRoute')
        this.$message(response.msg)
      }
    },
    // 下一步，预览提现
    async next () {
      await this.getFundRoute()
      if (!this.fundCode) return
      const response = await this.getLoanTrialX({
        loanTerm: this.form.applyTerm,
        withdrawAmt: this.form.applyAmt,
        loanPlatform: 'TMD',
        fundCode: this.fundCode,
        repayMethod: 'AI',
        productCd: 'TMDP'
      })
      if (response.success) {
        this.$storage.set('repayTrail', response.data)
        const couponSerialNos = this.couponSerialNos ? { couponSerialNos: this.couponSerialNos, couponType: this.couponType } : {}
        this.$router.push({ path: '/withdraw/preview2', query: { fundCode: this.fundCode, ...couponSerialNos, couponSerialId: this.$route.query.couponSerialId } })
      }
    },
    // 最大提现
    maxWithdraw () {
      this.$report({
        id: 10087
      })
      this.form.applyAmt = this.productMaxLimit
      this.$message(`已修改提现金额为${this.form.applyAmt}`)
    },

    // 怎么花
    purposeChange (item) {
   
    },

    // 期数选择
    termChange (item) {
     
    },

    initDataEvent () {
      window.addEventListener('deviceorientation', this.orientationEvent)
    },

    destoryDataEvent () {
      window.removeEventListener(
        'deviceorientation',
        this.orientationEvent
      )
    },

    orientationEvent () {
      let now = Date.now()
      if (now - throttleLastTimer > throttleGutter) {
        this.deviceorientationEventOccurCount++
        throttleLastTimer = now
      }
    },
    confirm () {
      this.$report({ id: 10183 })
      this.form.applyAmt = this.productMaxLimit
      this.tipsVisible = false
    },
    cancel () {
      this.$report({ id: 10184 })
      this.tipsVisible = false
    },
    // 修改提现金额
    detensionForChangeAmount () {
      this.continueApply()
    },
    back () {
      this.$router.replace('/')
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page.withdraw-index {
    height: 100%;
    position: relative;
    background-color: #fafafa;
    box-sizing: border-box;
    .card-panel {
        background-color: #fff;
        margin-top: 20px;
    }

    /*金额选择*/
    .withdraw-money {
        padding: 0 30px;
        padding-bottom: 20px;

        .title {
            font-size: 30px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #333;
            padding-top: 50px;
            padding-bottom: 10px;
        }

        .money-operate {
            height: 88px;
            line-height: 88px;
            display: flex;
            flex-direction: row;
            align-items: center;
            border-bottom: 1px solid #eee;

            .money {
                font-size: 72px;
                font-family: DIN-Medium;
                font-weight: 400;
                float: left;
                flex: 1;
            }

            .max-withdraw {
                font-size: 28px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                height: 60px;
                line-height: 60px;
                width: 190px;
                box-sizing: border-box;
                text-align: center;
                border: 1px solid #ff3446;
                color: #ff3446;
                border-radius: 40px;
            }
        }

        .money-range {
            height: 88px;
            line-height: 88px;
            font-size: 30px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #999;

            .min-money {
                float: left;
            }

            .max-money {
                float: right;

                em {
                    font-style: normal;
                }
            }
        }
    }
    .ssvip-banner{
        width: 690px;
        height: 110px;
        background-size: cover;
        border-radius: 14px;
        padding:27px 0 0 127px;
        margin:20px auto 20px;
        .s-title{
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #763E12;
        }
        .s-content{
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763E12;
        }
    }
    .tips {
        padding: 27px 40px;
        background: rgba(255, 249, 241, 1);
        font-size: 24px;
        color: rgba(255, 136, 100, 1);
        line-height: 33px;
    }
    .form {
        padding: 0 30px;

        .form-item {
            height: 110px;
            line-height: 110px;
            margin-top: 0;

            .nd-choose {
                label {
                    font-size: 30px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                }

                input {
                    font-size: 30px;
                }

                textarea {
                    font-size: 30px;
                }
            }
        }
    }
    .svip-banner{
        width: 710px;
        background: #FFF0DD;
        border-radius: 20px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #945612;
        line-height: 33px;
        padding:22px 28px 0 16px;
        display: flex;
        margin:30px auto 0;
        .red{
            color:#FF4633
        }
        >img{
            width:100px;
            height:88px;
        }
        .svip-banner-content{
            padding-left:5px;
        }
    }
    > .bottom {
        width: 750px;
        height: 230px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.04);
        position: fixed;
        bottom: 0;
        .read-protocol {
            width: 100%;
            text-align: center;
            margin-top: 25px;
            span {
              display: block;
                font-family: 'PingFangSC-Regular';
                font-weight: 400;
                color: #666;
                font-size: 24px;
                line-height: 33px;
            }
        }
        .confirm {
            width: 650px;
            height: 94px;
            border-radius: 47px;
            margin: 30px auto 0;
        }
    }
    .tips-content {
        padding: 20px 50px 70px;
        .header {
            font-size: 42px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 59px;
        }
        .body {
            margin-top: 26px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
            .highlight {
                color: #ff3446;
            }
        }
        .footer {
            display: block;
            width: 460px;
            height: 80px;
            line-height: 80px;
            margin: 90px auto 0;
        }
        .cancel {
            margin-top: 40px;
            font-size: 28px;
            color: rgba(142, 178, 216, 1);
            line-height: 40px;
            text-decoration: underline;
            text-align: center;
        }
    }
    .detention-dialog {
        .detention-title {
            margin: 0 58px;
            text-align: center;
            font-size: 36px;
            line-height: 50px;
            font-family: PingFangSC-Medium,PingFang SC;
            font-weight: 500;
            padding-bottom: 34px;
            border-bottom: 1px solid #EEEEEE;
            span {
                font-size:36px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(255,70,51,1);
                line-height:50px;
            }
        }

        .giveup {
            li {
                height: 110px;
                line-height: 110px;
                text-align: center;
                font-size: 30px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: @fc3;
                border-bottom: 1px solid #EEEEEE;
            }
        }

        .continue {
            border: 0px solid transparent;
            height: 160px;
            line-height: 160px;
            text-align: center;
            font-size: 36px;
            font-family: PingFangSC-Medium,PingFang SC;
            font-weight: 500;
            color: @theme;
            width: 100%;
            -webkit-appearance: none;
            appearance: none;
            outline: none;
            background-color: #FFFFFF;
        }
    }

    .activity-dialog {
        .activity-content {
            padding: 0 60px;
            padding-top: 42px;
            padding-bottom: 42px;

            .slogan {
                height: 42px;

                img {
                    height: 100%;
                    width: unset;
                }
            }

            .text {
                font-size: 32px;
                font-family: PingFangSC-Regular,PingFang SC;
                color: @fc1;
                font-weight: 400;
                margin-top: 43px;
            }

            p {
                font-size: 32px;
                font-family: PingFangSC-Regular,PingFang SC;
                color: @fc1;
                font-weight: 400;

                em {
                    font-style: normal;
                    color: @theme;
                }
            }

            .description {
                width: 500px;
                height: 130px;
                background-color: #FFF0F0;
                padding: 29px 0;
                border-radius: 16px;
                margin-top: 55px;
                padding-left: 141px;
                position: relative;

                .desc-image {
                    height: 160px;
                    width: 116px;
                    background-image: url(../authentication/images/img_ren@2x.png);
                    position: absolute;
                    left: 30px;
                    bottom: 0px;
                    background-size: cover;
                }

                p {
                    font-size: 24px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    color: @fc2;
                    line-height: 1.6em;
                }
            }

            .continue-btn {
                width: 440px;
                margin: 0 auto;
                height: 80px;
                line-height: 80px;
                font-size: 36px;
                font-weight: 600;
                margin-top: 70px;
            }

            .giveup-btn {
                height: 40px;
                font-size: 28px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                line-height: 40px;
                color: @fc3;
                text-decoration: underline;
                text-align: center;
                margin-top: 22px;
            }
        }

        .activity-template-content {
            width: 620px;
            height: 750px;
            background-size: contain;
            position: relative;

            .button-group {
                position: absolute;
                bottom: 48px;
                left: 50%;
                transform: translateX(-50%);

                .continue-btn {
                    width: 440px;
                    margin: 0 auto;
                    height: 80px;
                    line-height: 80px;
                    font-size: 36px;
                    font-weight: 600;
                    margin-top: 70px;
                }

                .giveup-btn {
                    height: 40px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    line-height: 40px;
                    color: @fc3;
                    text-decoration: underline;
                    text-align: center;
                    margin-top: 22px;
                }
            }
        }
    }
    .pricingPopup-dialog{
        .pricingPopup{
            padding:0 0 40px 0;
            &-tip{
                margin-left:45px;
                height: 72px;
                font-size: 42px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 72px;
            }
            p{
                margin-left:45px;
                margin-top:34px;
                margin-right:35px;
                height: 80px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 40px;
            }
            &-content{
                margin-top:20px;
            }
            &-button{
                margin:63px auto 0;
                width: 320px;
                height: 80px;
                line-height: 80px;
                background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
                border-radius: 40px;
            }
        }
    }
    .dialog{
        position: relative;
        .huang-guan{
          position: absolute;
          background: url('./image/img_0@2x.png');
          background-size:cover;
          width:420px;
          height:136px;
          top:-134px;
          left:106px;
        }
        &-top{
        width: 620px;
        height: 153px;
        background: linear-gradient(90deg, #FCD5AC 0%, #FEF6E4 100%);
        border-radius: 30px;
        padding-top:40px;
        margin-top:-40px;
        text-align: center;
        .success{
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #763E12;
        }
        .ji-huo{
            font-size: 24px;
            color: #763E12;
            padding-top:5px;
        }
        }
        &-center{
        display: flex;
        justify-content:space-between;
        width: 444px;
        margin:30px auto 0;
        &-left,&-right{
            display: flex;
            flex-direction: column;
            align-items:center;
            width: 207px;
            height: 167px;
            background: #FFF7E5;
            border-radius: 14px;
            padding-top:25px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            >img{
            width:80px;
            height:80px;
            }
            >p{
            margin-top:15px;
            font-size: 24px;
            color: #763E12;
            }
        }
        }
        &-bottom{
        display: flex;
        justify-content:space-between;
        margin-bottom: 50px;
        .dialog-white,.dialog-red{
            width: 270px;
            line-height: 80px;
            height: 80px;
            margin:50px auto 0;
            border-radius: 47px;
            text-align: center;
            font-size: 30px;
        }
        .dialog-white{
                border: 1px solid #FF4633;
                color: #FF4633;
                background:white;
            }
            .dialog-red{
                background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
                color: #FFFFFF;
            }
        }
  }
}
</style>
